// source: acompanha/payment_fees/v1/payment_fees.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest', null, global);
goog.exportSymbol('proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse', null, global);
goog.exportSymbol('proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest', null, global);
goog.exportSymbol('proto.acompanha.payment_fees.v1.ListPaymentFeesRequest', null, global);
goog.exportSymbol('proto.acompanha.payment_fees.v1.ListPaymentFeesResponse', null, global);
goog.exportSymbol('proto.acompanha.payment_fees.v1.PaymentFee', null, global);
goog.exportSymbol('proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest', null, global);
goog.exportSymbol('proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.payment_fees.v1.PaymentFee = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.payment_fees.v1.PaymentFee, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.payment_fees.v1.PaymentFee.displayName = 'proto.acompanha.payment_fees.v1.PaymentFee';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.payment_fees.v1.ListPaymentFeesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.displayName = 'proto.acompanha.payment_fees.v1.ListPaymentFeesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.payment_fees.v1.ListPaymentFeesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.displayName = 'proto.acompanha.payment_fees.v1.ListPaymentFeesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.displayName = 'proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.displayName = 'proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.displayName = 'proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.displayName = 'proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.displayName = 'proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.payment_fees.v1.PaymentFee.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.payment_fees.v1.PaymentFee} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.PaymentFee.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 2, ""),
feePercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
validFrom: jspb.Message.getFieldWithDefault(msg, 4, ""),
validTo: jspb.Message.getFieldWithDefault(msg, 5, ""),
notes: jspb.Message.getFieldWithDefault(msg, 6, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee}
 */
proto.acompanha.payment_fees.v1.PaymentFee.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.payment_fees.v1.PaymentFee;
  return proto.acompanha.payment_fees.v1.PaymentFee.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.payment_fees.v1.PaymentFee} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee}
 */
proto.acompanha.payment_fees.v1.PaymentFee.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFeePercent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidFrom(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidTo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.payment_fees.v1.PaymentFee.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.payment_fees.v1.PaymentFee} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.PaymentFee.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFeePercent();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getValidFrom();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getValidTo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string payment_method = 2;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double fee_percent = 3;
 * @return {number}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.getFeePercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.setFeePercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string valid_from = 4;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.getValidFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.setValidFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string valid_to = 5;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.getValidTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.setValidTo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
*/
proto.acompanha.payment_fees.v1.PaymentFee.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
*/
proto.acompanha.payment_fees.v1.PaymentFee.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee} returns this
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.payment_fees.v1.PaymentFee.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.payment_fees.v1.ListPaymentFeesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.payment_fees.v1.ListPaymentFeesRequest}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.payment_fees.v1.ListPaymentFeesRequest;
  return proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.payment_fees.v1.ListPaymentFeesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.payment_fees.v1.ListPaymentFeesRequest}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.payment_fees.v1.ListPaymentFeesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.payment_fees.v1.ListPaymentFeesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
feesList: jspb.Message.toObjectList(msg.getFeesList(),
    proto.acompanha.payment_fees.v1.PaymentFee.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.payment_fees.v1.ListPaymentFeesResponse}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.payment_fees.v1.ListPaymentFeesResponse;
  return proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.payment_fees.v1.ListPaymentFeesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.payment_fees.v1.ListPaymentFeesResponse}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.payment_fees.v1.PaymentFee;
      reader.readMessage(value,proto.acompanha.payment_fees.v1.PaymentFee.deserializeBinaryFromReader);
      msg.addFees(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.payment_fees.v1.ListPaymentFeesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFeesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.payment_fees.v1.PaymentFee.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PaymentFee fees = 1;
 * @return {!Array<!proto.acompanha.payment_fees.v1.PaymentFee>}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.prototype.getFeesList = function() {
  return /** @type{!Array<!proto.acompanha.payment_fees.v1.PaymentFee>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.payment_fees.v1.PaymentFee, 1));
};


/**
 * @param {!Array<!proto.acompanha.payment_fees.v1.PaymentFee>} value
 * @return {!proto.acompanha.payment_fees.v1.ListPaymentFeesResponse} returns this
*/
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.prototype.setFeesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.payment_fees.v1.PaymentFee=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.payment_fees.v1.PaymentFee}
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.prototype.addFees = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.payment_fees.v1.PaymentFee, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.payment_fees.v1.ListPaymentFeesResponse} returns this
 */
proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.prototype.clearFeesList = function() {
  return this.setFeesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentMethod: jspb.Message.getFieldWithDefault(msg, 1, ""),
feePercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
validFrom: jspb.Message.getFieldWithDefault(msg, 3, ""),
validTo: jspb.Message.getFieldWithDefault(msg, 4, ""),
notes: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest;
  return proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFeePercent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidFrom(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidTo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFeePercent();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getValidFrom();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValidTo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string payment_method = 1;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double fee_percent = 2;
 * @return {number}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.getFeePercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.setFeePercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string valid_from = 3;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.getValidFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.setValidFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string valid_to = 4;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.getValidTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.setValidTo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string notes = 5;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.payment_fees.v1.PaymentFee.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse;
  return proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.payment_fees.v1.PaymentFee;
      reader.readMessage(value,proto.acompanha.payment_fees.v1.PaymentFee.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.payment_fees.v1.PaymentFee.serializeBinaryToWriter
    );
  }
};


/**
 * optional PaymentFee data = 1;
 * @return {?proto.acompanha.payment_fees.v1.PaymentFee}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.payment_fees.v1.PaymentFee} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.payment_fees.v1.PaymentFee, 1));
};


/**
 * @param {?proto.acompanha.payment_fees.v1.PaymentFee|undefined} value
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse} returns this
*/
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse} returns this
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 2, ""),
feePercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
validFrom: jspb.Message.getFieldWithDefault(msg, 4, ""),
validTo: jspb.Message.getFieldWithDefault(msg, 5, ""),
notes: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest;
  return proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFeePercent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidFrom(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidTo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFeePercent();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getValidFrom();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getValidTo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string payment_method = 2;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double fee_percent = 3;
 * @return {number}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.getFeePercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.setFeePercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string valid_from = 4;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.getValidFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.setValidFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string valid_to = 5;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.getValidTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.setValidTo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.payment_fees.v1.PaymentFee.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse;
  return proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.payment_fees.v1.PaymentFee;
      reader.readMessage(value,proto.acompanha.payment_fees.v1.PaymentFee.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.payment_fees.v1.PaymentFee.serializeBinaryToWriter
    );
  }
};


/**
 * optional PaymentFee data = 1;
 * @return {?proto.acompanha.payment_fees.v1.PaymentFee}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.payment_fees.v1.PaymentFee} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.payment_fees.v1.PaymentFee, 1));
};


/**
 * @param {?proto.acompanha.payment_fees.v1.PaymentFee|undefined} value
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse} returns this
*/
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse} returns this
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest}
 */
proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest;
  return proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest}
 */
proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest} returns this
 */
proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.payment_fees.v1);
